import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import {
  type CreateMerchantFeeDto,
  type MerchantFeeDto,
  postMerchantsPublicIDFees,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = { data: CreateMerchantFeeDto; publicID: string };

type Props = {
  onSuccess?: (data: MerchantFeeDto) => void;
  onError?: () => void;
};

export const useCreateMerchantFeeMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ data, publicID }: Parameters) =>
        postMerchantsPublicIDFees(data, publicID),
    ),
    onSuccess: (data: MerchantFeeDto, { publicID }: Parameters) => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.byMerchantPublicId(publicID),
      });
      onSuccess?.(data);
    },
    onError,
  });
};
